/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

/** Refresh when context token has fewer than this many ms remaining.
 *  Per CTR-PL-MS-OFFICESSO-001 v1.0.0 §5.2: 300 seconds (5 minutes). */
export const REFRESH_THRESHOLD_MS = 300_000;

/** Maximum retry attempts for SSO bootstrap failures */
export const MAX_BOOTSTRAP_RETRIES = 2;

/** Delay before retry on PREMATURE_SSO_TOKEN (clock skew).
 *  Per CTR-PL-MS-OFFICESSO-001 v1.0.0 §6.1: 5 seconds. */
export const PREMATURE_TOKEN_RETRY_DELAY_MS = 5_000;

/** Platform SSO exchange endpoint path */
export const SSO_EXCHANGE_PATH = '/platform/auth/office-sso';

/** Delay between Office SSO bootstrap retries (bootstrap-only; not contract-specified). */
export const BOOTSTRAP_RETRY_DELAY_MS = 500;

/** Maximum loops when resolving EXPIRED_SSO_TOKEN during exchange (safety bound). */
export const MAX_EXPIRED_SSO_RECOVERY_ATTEMPTS = 5;
